import { PublicService, serviceEndpointsFromEnv } from '@pok/service-endpoints';

const { publicUrl } = serviceEndpointsFromEnv(import.meta.env);

export const KYC_API = publicUrl(PublicService.KYC);
export const CERTIFIER_ROOT = publicUrl(PublicService.CERTIFIER);
export const MARKETING_API = publicUrl(PublicService.MARKETING);
